import { showFailed } from "../../Customs/SweetAlerts";
import axiosInstance from "../../Middleware/AxiosInstanceInterceptor";

// fetch Roles
export const fetchCMSRole = async (params) => {
    try {
        const url = "/cms-roles";
        const qp = new URLSearchParams();

        if (typeof params === "string") {
            qp.append("search", params);
        } else if (params && typeof params === "object") {
            const { page, limit, name, email, search } = params;
            if (search) {
                qp.append("search", search);
            } else {
                // Prefer name, then email. Avoid duplicating the same term twice.
                const term = name || email;
                if (term) qp.append("search", term);
            }
            if (Number.isInteger(page) || (typeof page === 'string' && page.trim() !== '')) qp.append("page", page);
            if (limit) qp.append("limit", limit);
        }

        const queryString = qp.toString() ? `?${qp.toString()}` : "";
        const response = await axiosInstance.get(`${url}${queryString}`);
        const data = response.data;

        if (response.status === 200) {
            return data;
        } else {
            showFailed('Failed.', `${data?.error}`);
        }
    }
    catch (error) {
        const msg = error?.response?.statusText || error?.message || 'Unknown error';
        showFailed('Failed.', `${msg}`);
    }
}

// Get CMS User by ID
export const getCMSRoleById = async (userId) => {
    try {
        const response = await axiosInstance.get(`/cms-roles/${userId}`);
        const data = response.data;

        if (response.status === 200) {
            return data;
        } else {
            showFailed('Failed.', `${response.status}`);
            throw new Error("Failed to fetch data. Status: " + response.status);
        }
    } catch (error) {
        showFailed('Failed.', `${error.response.data.error[0]}`);
        throw new Error('Error retrieving user data:', error);
    }
};